define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action",
	"csi/action/FormData",
	"csi/reflection",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Specification/BOM/PartMaterialBOMSectionMixin"
], function(declare,lang,csi,action,FormData,reflection,NewFrom,ActionControllerMixin,xml,Query,PartMaterialBOMSectionMixin) {
	var INDEX_THEME_PAGE = 0;
	var INDEX_PLACEMENT_PAGE = 1;

	return declare([NewFrom, ActionControllerMixin,PartMaterialBOMSectionMixin], {
		// FormData: form data storing selected Theme and Theme Placements
		_fdTheme: null,
		_fdItems: null,

		preProcess: function() {
			// summary: cache form data for later
			this._fdItems = this._getThemePlacementsFormData();
			this._fdTheme = this._getThemeFormData();

			lang.mixin(this._fdTheme, {
				m_bOmitSelections: true,
				m_bRequireOne: true,
				m_bSelectOne: true
			});

			this.inherited(arguments);
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			var qr = this.widget.getQueryResultByDomNode(this.refNode);
			var bomSectionDefUrl = qr.parentResult.groupValue;
			var bomSectionDef = (xml.isValidURL(bomSectionDefUrl)) ? this.m_cache.getNode(bomSectionDefUrl) : null;

			var q = new Query();
			// The type must be checked because table can be grouped by attributes other than BOM section
			if (bomSectionDef && bomSectionDef.$Type == "BOMSectionDefinition" && !bomSectionDef.AdHoc) {
				if (index == INDEX_THEME_PAGE) {
					// C8-2440: if the Section is formal (site-level) then only display Themes that use this Section
					q.RefAttr("AllSections", xml.OP_EQUALS, bomSectionDefUrl);
				} else if (index == INDEX_PLACEMENT_PAGE) {
					q.RefAttr("DSSection", xml.OP_EQUALS, bomSectionDefUrl);
				} else {
					return this.inherited(arguments);
				}
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var	bRefresh = false;
			var	dfd, fd;

			switch (wizard.getIndexOfPage(nextPage)) {
				case INDEX_THEME_PAGE: {
					// Select Theme
					fd = this._fdTheme;
					fd.setNode(wizard.getViewNode());
					break;
				}
				case INDEX_PLACEMENT_PAGE: {
					// Select MaterialPlanPlacement - show view of selected Theme's MaterialPlanPlacement
					var	nodeTheme = wizard.getFormDataFromPage(currentPage).getSelectedNode();

					// the next page may already have form data if user used back button; if so,
					// then just use form data already there; otherwise, use wizard's form data for
					// last page since that is what will be fed into NewFrom controller for processing
					fd = this._fdItems;

					// if form data node has changed, then reset selections and refresh view
					if (fd.getNode() != nodeTheme) {
						fd.resetSelections();
						fd.setNode(nodeTheme);
						bRefresh = true;
					}

					break;
				}
			}

			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		_getThemeFormData: function() {
			// summary: use new form data to store bom selection
			return new FormData(this);
		},

		_getThemePlacementsFormData: function() {
			// summary: use controller form data to store part material selections
			return this.getFormData();
		}
	});
});